// StepGradient shader aligned to ChaosWavesBg visual (uses ChaosWaves logic)
// Users can still override at runtime by registering with the same name
const defaultStepGradient = `
precision mediump float;

uniform vec2 u_resolution;
uniform float u_time;
uniform float u_speed;
uniform float u_seed;

uniform vec3 u_color_0;
uniform vec3 u_color_1;
uniform vec3 u_color_2;
uniform vec3 u_color_3;
uniform vec3 u_color_4;
uniform vec3 u_color_5;

// Key controls mapped from ChaosWavesBg
uniform float u_expand;  // recommend ~6.0
uniform float u_random;  // recommend ~5.0 - 15.0

varying vec2 vUv;

vec3 lut( float x ) {
    if(x<0.0 || x>1.0)
        return u_color_0;

    vec3 color = vec3(1.0);
    
    float P1 = abs(x - 0.0);
    float P2 = abs(x - 0.167);
    float P3 = abs(x - 0.334);
    float P4 = abs(x - 0.500);
    float P5 = abs(x - 0.667);
    float P6 = abs(x - 0.833);
    float P7 = abs(x - 1.0);
    
    float R1 = smoothstep( 1., -0.0, P1 * u_expand) / 1.;
    float R2 = smoothstep( 1., -0.0, P2 * u_expand) / 1.;
    float R3 = smoothstep( 1., -0.0, P3 * u_expand) / 1.;
    float R4 = smoothstep( 1., -0.0, P4 * u_expand) / 1.;
    float R5 = smoothstep( 1., -0.0, P5 * u_expand) / 1.;
    float R6 = smoothstep( 1., -0.0, P6 * u_expand) / 1.;
    float R7 = smoothstep( 1., -0.0, P7 * u_expand) / 1.;
    
    color = u_color_0 * R1 + 
            u_color_1 * R2 +
            u_color_2 * R3 +
            u_color_3 * R4 +
            u_color_4 * R5 + 
            u_color_5 * R6 +
            u_color_0 * R7;
    
    return color;
}

float rand(vec2 n) { 
    return fract(sin(dot(n, vec2(12.9898, 4.1414)) + u_seed * 12.345) * (43758.5453 + u_seed * 1.234));
}

float noise(vec2 p){
    vec2 ip = floor(p);
    vec2 u = fract(p);
    u = u*u*(3.0-2.0*u);

    float res = mix(
        mix(rand(ip),rand(ip+vec2(1.0,0.0)),u.x),
        mix(rand(ip+vec2(0.0,1.0)),rand(ip+vec2(1.0,1.0)),u.x),u.y);
    return res*res;
}

const mat2 mtx = mat2( 0.80,  0.60, -0.60,  0.80 );

float fbm( vec2 p )
{
    float f = 0.0;

    vec2 seedOffset = vec2(u_seed * 0.0017, u_seed * 0.0031);
    f += 0.500000*noise( p + seedOffset ); p = mtx * p * 2.02;
    float t = u_time * u_speed;
    f += 0.031250*noise( p + t + seedOffset.x ); p = mtx * p * 2.01;
    f += 0.250000*noise( p + t + seedOffset.y ); p = mtx * p * (1.03 + u_random);
    f += 0.125000*noise( p + seedOffset.xy ); p = mtx * p * 2.01;
    f += 0.062500*noise( p + t + seedOffset.yx ); p = mtx * p * 2.04;
    f += 0.015625*noise( p + sin(t) + seedOffset.xx );

    return f/0.96875;
}

float pattern( in vec2 p )
{
    return fbm( p + fbm( p + fbm( p + fbm(p) ) ) );
}

void main()
{
    float shade = pattern(vUv);
    vec3 color = lut(shade);
    gl_FragColor = vec4( color, 1.0);
}
`;

const shader = {
  name: 'Chaos',
  shader: {
    frag: defaultStepGradient,
  },
  schema: [
    {
      key: 'colors',
      type: 'color-palette',
      label: 'Colors',
      min: 2,
      max: 6,
      default: ['#00ffff', '#2575fc', '#ffffff'],
    },
    {
      key: 'u_expand',
      type: 'number',
      label: 'Expand',
      min: 0.5,
      max: 20,
      step: 0.5,
      default: 6,
    },
    {
      key: 'u_random',
      type: 'number',
      label: 'Random',
      min: 0,
      max: 20,
      step: 0.5,
      default: 10,
    },
    { key: 'u_speed', type: 'number', label: 'Speed', min: 0, max: 10, step: 0.1, default: 1 },
    { key: 'animated', type: 'boolean', label: 'Animated', default: false },
  ],
  examples: [
    'dynamic-shader(Chaos, colors=#0ff,#2575fc,#ffffff; u_expand=6; u_random=10; animated=false)',
    'dynamic-shader(Chaos, colors=#ff7e5f,#feb47b,#2b5876,#4e4376; u_expand=8; u_random=12; animated=false)',
    'dynamic-shader(Chaos, colors=#111,#333,#777; u_expand=5; u_random=7; animated=false)',
  ],
};

export default shader;
